import { META } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#1F1B17] text-[#E8DCC1] mt-12">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14 grid md:grid-cols-[1.4fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif text-3xl text-[#E8DCC1]" dangerouslySetInnerHTML={{ __html: META.brand }} />
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E] mt-2" dangerouslySetInnerHTML={{ __html: META.tag + ' · est. ' + META.est }} />
          <p className="text-sm text-[#E8DCC1]/60 mt-5 leading-[1.7] max-w-md">A small firm, regulated by the SRA · Reg. 008-1934. Held in partnership. Twenty-eight solicitors and trainees, retained by approximately one hundred and twenty principal clients.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E] mb-3">Chambers</p>
          <p className="text-sm text-[#E8DCC1]/85 leading-relaxed">8 New Square<br />Lincoln's Inn, London WC2A 3QP</p>
          <p className="font-mono text-[11px] text-[#E8DCC1]/55 mt-3">+44 20 7993 0934</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E] mb-3">Regulatory</p>
          <ul className="text-sm text-[#E8DCC1]/85 space-y-1"><li>SRA Reg. 008-1934</li><li>Member · Law Society</li><li>STEP-affiliated</li><li>Lloyd's & the City</li></ul>
        </div>
      </div>
      <div className="border-t border-[#E8DCC1]/15 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#E8DCC1]/40">
        <span>© 2026 Sterling & Hayes Solicitors LLP · Held in partnership</span>
        <div className="flex gap-6"><button onClick={() => setPage('counsel')} className="hover:text-[#B68F4E]">Counsel</button><a href="#" className="hover:text-[#B68F4E]">Privacy</a></div>
      </div>
    </footer>
  );
}
